import { inject } from '@angular/core';
import { isDutch } from './is-dutch';

export function getDoodBrand(): string {
  if (inject(isDutch)) {
    return 'Miam Company';
  }
  return 'Dood';
}
